import * as L from 'leaflet';
import { Marker } from 'react-leaflet';
import './style.scss';
import { ICoordinate } from '../../../../../../../../models/coordinate.model';
import { FormFactor } from '../../../../../../../../models/labs/micromobility/form-factor.enum';
import { PropulsionType } from '../../../../../../../../models/labs/micromobility/propulsion-type.enum';
import { DateHelper } from '../../../../../../../../helpers/date.helper';
import electricScooterIcon from '../../../../../../../../../assets/icons/micromobility-scooter-dark.svg';
import electricBikeIcon from '../../../../../../../../../assets/icons/micromobility-bike-electric-assist-dark.svg';
import stationBikeIcon from '../../../../../../../../../assets/icons/station-bike-dark.svg';
import DataUrlHelper from '../../../../../../../../helpers/data-url.helper';

function createMicromobilityIconHtml(formFactor: FormFactor, propulsionType: PropulsionType, timeString: string): string {
  let result = '<div class="bg-white rounded d-flex align-items-center small" style="padding: 0.125rem 0.25rem">';

  let transportModeIconSource = '';
  if (formFactor === FormFactor.Scooter) transportModeIconSource = DataUrlHelper.encode(electricScooterIcon);
  else if (formFactor === FormFactor.Bicycle && propulsionType === PropulsionType.ElectricAssist) transportModeIconSource = DataUrlHelper.encode(electricBikeIcon);
  else if (formFactor === FormFactor.Bicycle) transportModeIconSource = DataUrlHelper.encode(stationBikeIcon);

  if (transportModeIconSource) {
    result += `<img
            src="${transportModeIconSource}"
            alt=""
            class="me-1"
            style="height:1.5rem"
        />`;
  }

  if (timeString) {
    result += `<span class="fw-bold">${timeString}</span>`;
  }

  result += '</div>';

  return result;
}

function MicromobilityLinkLabelMarker({
  coordinate,
  time,
  formFactor,
  propulsionType,
  disabled,
}: {
  coordinate: ICoordinate;
  time: string;
  formFactor: FormFactor;
  propulsionType: PropulsionType;
  disabled: boolean;
}) {
  const icon = L.divIcon({
    className: `micromobility-link-label-marker w-auto h-auto ${disabled ? 'micromobility-link-label-marker--disabled' : ''}`,
    html: createMicromobilityIconHtml(formFactor, propulsionType, DateHelper.getTimeFromDateTimeString(time)),
    iconAnchor: [-10, -3],
  });

  return <Marker icon={icon} position={[coordinate.latitude, coordinate.longitude]} />;
}

export default MicromobilityLinkLabelMarker;
